// Wrap All in one Div JS Start

function wrapThemeBlocks() {
  const title = document.querySelector(".theme-block.title");
  const text = document.querySelector(".theme-block.text");

  // Ensure both elements exist and are not already wrapped
  if (title && text && !document.querySelector(".theme-block--wrapper")) {
    // Create new wrapper div
    const wrapper = document.createElement("div");
    wrapper.classList.add("theme-block--wrapper");

    // Insert wrapper before title
    title.parentNode.insertBefore(wrapper, title);

    // Move title and text inside wrapper
    wrapper.appendChild(title);
    wrapper.appendChild(text);
  }
}

// Run on load and when window resizes/orientation changes
document.addEventListener("DOMContentLoaded", wrapThemeBlocks);
window.addEventListener("resize", wrapThemeBlocks);
window.addEventListener("orientationchange", wrapThemeBlocks);
// Wrap All in one Div JS End

function setActiveMenuLink() {
  const current = window.location.pathname.toLowerCase();
  console.log(current, '--current');

  const links = document.querySelectorAll('.gm-target');
  if (!links.length) return false;
  links.forEach(link => {
    const href = (link.getAttribute('href') || '').toLowerCase();
    if (current === href) {
      console.log(href, '--href');
      console.log('In the loop');
      const li = link.closest('.gm-item');
      setTimeout(() => {
        link.classList.add('gm-menu-active');
        li?.classList.add('gm-link-active');
      }, 2000);
    }
  });
  return true;
}

const interval = setInterval(() => {
  const menuLoaded = document.querySelector('.gm-target');
  if (menuLoaded) {
    console.log('Loaded');
    const done = setActiveMenuLink();
    if (done) clearInterval(interval);
  }
}, 1000);
